<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <div
        v-if="mensagem !== ''"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog :id="'dialogEditCreditoUsuario'" titulo="Plano Cliente" ref="dialog" :modal="propView == 'modal'" :hideHeader="true">
        
        <div class="">

          <div class="row">
            <label class="col-sm-12 col-form-label">Informa a quantidade de creditos</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                type="text"
                v-model="item.quantidade"
                @keyup="enterSalvar"
              />
            </div>
          </div>

        </div>

        <template v-slot:rodape>
           <div class="row">
            <div class="col-md-12 col-sm-12 d-flex justify-content-center text-center">
              <button
                type="button"
                class="btn btn-secondary"
                v-if="view == 'modal'"
                @click="fechar()"                         
              >Cancelar</button>
              <button type="button" class="btn btn-primary" style="margin-left:10px" @click="salvar()">Inserir Credito</button>
            </div>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";


export default {
  name: "EditCreditoUsuario",
  components: { Dialog },
  props: {
    propView: { type: String, default: "modal" },
    propUsuario: { type: String, default: "" },
    propSite: { type: String, default: "" },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    retornaSite()
    {
      return this.$site;
    },
    async carregarItem() {

      //* Limpa os dados
      this.itemErros = util.errosLimpar(this.itemErros);
      this.item.quantidade = 0.00;
     
      

    },
    async salvar() {

    this.itemErros = util.errosLimpar(this.itemErros);
      
     //* Verifica se o usuario foi definido
     if (this.propUsuario !== "") {

        //* Envia os dados para a api
        var apiRequest = await api.post("/credito/usuario", {
          usuario:this.propUsuario,
          quantidade: this.item.quantidade
        });

        console.log(apiRequest.data);

        //* Verifica se ocorreu algum erro
        if (!apiRequest.data.erro) {

          //* Fecha a janela
          this.$refs.dialog.fechar();
          this.$emit("fechar",this.item);

        }else{

          if(apiRequest.data.erros)
          {
            util.errosProcessar(this.itemErros, apiRequest.data.erros);
          }
           
        }

      }

    },
    async enterSalvar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
    fechar()
    {
      this.$refs.dialog.fechar();
      this.$emit("fechar");
    },
    abrir()
    {
      this.$refs.dialog.abrir();
      this.carregarItem();
    }
  },
  async mounted() {

    this.view = this.propView;    
    
  },
  data: function () {
    return {
      item: {
        quantidade: 0.00,        
      },
      itemErros: {
        quantidade: { status: false, mensagem: "" }
      },
      view: "",
      mensagem: ""
    };
  },
  computed: {
    
  }
};
</script>

<style></style>
